import SigninForm from '../components/Forms/SigninForm';
import { useTranslation } from '../providers/i18next';
import PageBase from './PageLayout/PageBase';

const SigninResetPage = () => {
  const { txn } = useTranslation();

  return (
    <PageBase titleBase={txn('Sign In')}>
      <SigninForm resetMode />
    </PageBase>
  );
};

export default SigninResetPage;
